import React from "react";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import styles from "../style/Tabs.module.css";
import tabspic from "../images/card-2.jpeg";
// import tabspic from "../images/Tab-img.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboard,
  faTeeth,
  faTooth,
} from "@fortawesome/free-solid-svg-icons";
import ProgressBar from "../utility components/progressBar";
import { useNavigate } from "react-router-dom";

const Healthcare = () => {
  const navigate = useNavigate();

  const ToContact = () => {
    navigate("/#contact");
  };

  return (
    <div className={styles["healthcare-container"]}>
      <h2 className={styles["section-heading"]}>How It Works</h2>
      <h1 className={styles["main-heading"]}>New Smile in 3 Simple Steps</h1>
      <Tabs>
        <TabList className={styles["tab-list"]}>
          <Tab
            className={styles["tab"]}
            selectedClassName={styles["selected-tab"]}
          >
            <FontAwesomeIcon
              icon={faClipboard}
              className={styles["tab-icon"]}
            />
            <span>Step 1</span>
          </Tab>
          <Tab
            className={styles["tab"]}
            selectedClassName={styles["selected-tab"]}
          >
            <FontAwesomeIcon icon={faTooth} className={styles["tab-icon"]} />
            <span>Step 2</span>
          </Tab>
          <Tab
            className={styles["tab"]}
            selectedClassName={styles["selected-tab"]}
          >
            <FontAwesomeIcon icon={faTeeth} className={styles["tab-icon"]} />
            <span>Step 3</span>{" "}
          </Tab>
          <Tab
            className={styles["tab"]}
            selectedClassName={styles["selected-tab"]}
          >
            <FontAwesomeIcon icon={faTeeth} className={styles["tab-icon"]} />
            <span>New Smile</span>
          </Tab>
          {/* <Tab
            className={styles["tab"]}
            selectedClassName={styles["selected-tab"]}
          >
            <FontAwesomeIcon
              icon={faBriefcaseClock}
              className={styles["tab-icon"]}
            />
            <span>Dental Implants</span>
          </Tab> */}
        </TabList>
        <div className={styles["tabs-container"]}>
          <TabPanel>
            <div className={styles["tabs-content"]}>
              <div className={styles["content-box"]}>
                <h3>Free Consultation</h3>
                <p>
                  Schedule a consultation at one of our partner clinics for a
                  professional teeth scan and expert assessment.
                </p>
                {/* <ul className={styles["stats-list"]}>
                  <li className={styles["stats-item"]}>
                    {" "}
                    Nullam est <span>87%</span>
                    <ProgressBar percentage={87} />
                  </li>
                  <li className={styles["stats-item"]}>
                    Mattis dictum nunc <span>80%</span>
                    <ProgressBar percentage={80} />
                  </li>
                  <li>
                    Malesuada dictum neque <span>86%</span>
                    <ProgressBar percentage={86} />
                  </li>
                </ul> */}
                {/* <button
                  className={styles["appointment-button"]}
                  onClick={() => ToContact()}
                >
                  Get Appointment
                </button> */}
              </div>
              <img
                src={tabspic}
                alt="Doctor"
                className={styles["doctor-image"]}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className={styles["tabs-content"]}>
              <div className={styles["content-box"]}>
                <h3>Smile Scan & Treatment Plan</h3>
                <p>
                  After your scan, our specialists will analyze your results to
                  create a personalized treatment plan, including:
                </p>
                <ul className={styles["stats-list"]}>
                  <li>The estimated duration of your treatment</li>
                  <li>The number of aligners needed for your transformation</li>
                  {/* <li>Number of invisible braces required</li> */}
                </ul>
                {/* <button
                  className={styles["appointment-button"]}
                  onClick={() => ToContact()}
                >
                  Get Appointment
                </button> */}
              </div>
              <img
                src={tabspic}
                alt="Pediatric Dentistry"
                className={styles["doctor-image"]}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className={styles["tabs-content"]}>
              <div className={styles["content-box"]}>
                <h3>Pick Up Your Invisible Aligners</h3>
                <p>
                  Once your aligners are ready, pick them up from our clinic and
                  start your journey. Your aligner kit includes:
                </p>
                <ul className={styles["stats-list"]}>
                  <li>A full set of customized invisible aligners</li>
                  <li>A protective case for safe storage</li>
                  {/* <li>Chewies</li> */}
                </ul>
              </div>
              <img
                src={tabspic}
                alt="Teeth Whitening"
                className={styles["doctor-image"]}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className={styles["tabs-content"]}>
              <div className={styles["content-box"]}>
                <h3>Your New Smile in 6 to 12 Months</h3>
                <p>For the best results:</p>
                <ul className={styles["stats-list"]}>
                  <li>Wear your aligners for 22 hours a day</li>
                  <li>Switch to a new set every two weeks</li>
                  <li>Maintain your results with retainers</li>{" "}
                </ul>
                <button
                  className={styles["appointment-button"]}
                  onClick={() => ToContact()}
                >
                  Get Appointment
                </button>
              </div>
              <img
                src={tabspic}
                alt="Dental Services"
                className={styles["doctor-image"]}
              />
            </div>
          </TabPanel>
          <TabPanel>
            <div className={styles["tabs-content"]}>
              <div className={styles["content-box"]}>
                <h3>Our Professional & Adict Doctors.</h3>
                <p>Information about Dental Implants.</p>
                <ul className={styles["stats-list"]}>
                  <li>
                    Nullam est <span>87%</span>
                    <ProgressBar percentage={87} />
                  </li>
                  <li>
                    Mattis dictum nunc <span>80%</span>
                    <ProgressBar percentage={80} />
                  </li>
                  <li>
                    Malesuada dictum neque <span>86%</span>
                    <ProgressBar percentage={86} />
                  </li>
                </ul>
                <button
                  className={styles["appointment-button"]}
                  onClick={() => ToContact()}
                >
                  Get Appointment
                </button>
              </div>
              <img
                src={tabspic}
                alt="Dental Implants"
                className={styles["doctor-image"]}
              />
            </div>
          </TabPanel>
        </div>
      </Tabs>
    </div>
  );
};

export default Healthcare;
